import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal,
} from 'react-bootstrap';
import BidSendForm from './BidSendForm';


function formatContactData(jsonObject) {
  return jsonObject.map(item => ({
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    value: item.id,
  }));
}


class BidSendModal extends React.Component {

  constructor(props) {
    super(props);
    this.send = this.send.bind(this);
  }
  send(values) {
    this.props.sendBid(this.props.bid.id, values);
    this.props.close();
  }
  render() {
    const contactOptions = formatContactData(this.props.bid.hotel.contacts);
    return (
      <Modal show={this.props.show} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Assign to Property</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Assign the bid to an existing user or invite a new user.</p>
          <BidSendForm
            onSubmit={this.send}
            options={contactOptions}
            handleClose={this.props.close}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}


BidSendModal.propTypes = {
  bid: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
};

BidSendModal.defaultProps = {
  bid: {
    contacts: [],
  },
};
export default BidSendModal;



// WEBPACK FOOTER //
// src/routes/booking/components/BidSendModal.js